import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  InputRef,
  Popover,
  Row,
  Select,
  Skeleton,
  Space,
  TableColumnType,
  Tooltip,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import ItemsService, {
  UnitTypes,
  UnitTypesOption,
  ICompositeUnitRequest,
  IUnitListResponse,
} from "../../Services/ItemsService";
import { useTheme } from "../../Context/ThemeContext";
import { useClient } from "../../Context/ClientContext";
import { ColumnsType } from "antd/es/table";
import {
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  FilterOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import UnitModel from "./AddItemUnit";
import InvoiceExportService from "../../Services/InvoiceExportDetails";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { notificationContext } from "../../Common/Routing/PageRoute";
import { FilterDropdownProps } from "antd/es/table/interface";
import {
  TextSearchTableEnum,
  TextSearchTableOption,
} from "../../Common/SearchTableOptions";
import { findUserOnlyOnePremission } from "../Users/Roles/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { tablePageSizeOptions } from "../../Common/ThemeSetting";

import CbTableWithPagination from "../../Components/CbTableWithPagination";
import {
  ICbTableParams,
  ICbPagingItems,
} from "../../Components/CbTableWithPagination";

interface IUnitDataType {
  key: string;
  sno: number;
  companyId: string;
  id: number;
  name: string;
  type: string;
  shortName: string;
  tAmount: number;
  system: boolean;
  unitCategory?: number;
  compositeUnits?: ICompositeUnitRequest[];
  decimalPlaces?: number;
}

const ItemsUnitsTable = () => {
  type DataIndex = keyof IUnitDataType;
  const { currentClient } = useClient();
  const { clientSpecificRole } = useUser();
  const { themeData } = useTheme();
  const { openNotification } = useContext(notificationContext);
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  const searchInput = useRef<InputRef>(null);
  const searchSelect = useRef<any>(null);
  const [openDropdown, setOpenDropdown] = useState<DataIndex | null>(null);
  const [width, setWidth] = useState<any>(window.innerWidth);
  const [page, setPage] = useState(1);
  const [pagingItems, setPagingItems] = useState<ICbPagingItems>({
    currentPage: 1,
    pageSize: themeData?.tablePageSize ?? 15,
  });
  const [unitsList, setUnitsList] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [searchUnit, setSearchUnit] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [openModel, setOpenModel] = useState<boolean>(false);
  const [unitData, setUnitData] = useState<any>({});
  const [trigger, setTrigger] = useState<boolean>(false);
  const [exportType, setExportType] = useState<number>(-1);
  const [exportUnitData, setExportUnitData] = useState<any[]>([]);
  const [filter, setfilter] = useState<any>({
    sortCol: "",
    sortDir: "",
  });
  const [searchText, setSearchText] = useState<string>("");
  const [confirmation, setConfirmation] = useState<boolean>(false);
  const [searchColumnCount, setSearchColumnCount] = useState<number>(0);

  const [searchColumns, setSearchColumns] = useState<any>({
    name: "",
    type: null,
    shortName: "",
    unitCategory: null,
  });
  const [searchColumnsDropDown, setSearchColumnsDropDown] = useState<{
    unitNameDropEnum: TextSearchTableEnum;
    shortNameDropEnum: TextSearchTableEnum;
  }>({
    unitNameDropEnum: TextSearchTableEnum.contains,
    shortNameDropEnum: TextSearchTableEnum.contains,
  });

  useEffect(() => {
    if (currentClient?.id && (exportType === -1 || exportType)) {
      const requestModel = {
        unitName: searchColumns.name,
        unitNameDropEnum: searchColumnsDropDown.unitNameDropEnum,
        type: searchColumns.type,
        shortName: searchColumns.shortName,
        shortNameDropEnum: searchColumnsDropDown.shortNameDropEnum,
        unitCategory: searchColumns.unitCategory,
      };
      getUnitsList(
        currentClient?.id,
        exportType >= 1
          ? 0
          : (pagingItems.currentPage - 1) * pagingItems.pageSize,
        exportType >= 1 ? 0 : pagingItems.pageSize,
        filter.sortCol,
        filter.sortDir,
        searchUnit,
        searchColumnCount,
        requestModel
      );
    } else if (currentClient?.id === null) {
      console.error("currentClient is null Items");
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    trigger,
    pagingItems.currentPage,
    pagingItems.pageSize,
    searchUnit,
    // location.pathname,
    filter.sortCol,
    filter.sortDir,
    exportType,
    searchColumns,
    //searchColumnsDropDown,
    //searchColumnCount,
  ]);
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchUnit(searchText);
      setPagingItems((prev) => ({ ...prev, currentPage: 1 })); // reset to page 1
      setExportUnitData([]);
      setExportType(-1);
    }, 1000); //

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);
  // --------- Get Units TableData API ---------
  const getUnitsList = async (
    clientId: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    searchColumnCount?: number,
    requestModel?: any
  ) => {
    if (exportType < 1) {
      setLoading(true);
    }
    await ItemsService.getUnitsList(
      clientId,
      start,
      length,
      sortCol,
      sortDir,
      search,
      searchColumnCount,
      requestModel
    )
      .then((res: any) => {
        if (res.result?.items?.length > 0) {
          // console.log(res.result.items);
          let unitData = res.result.items?.map((v: any, i: any) => {
            return {
              key: v.id,
              companyId: v?.companyId,
              name: v?.name,
              type: v?.type,
              shortName: v?.shortName,
              sno: v?.sno,
              id: v?.id,
              system: v?.system,
              isBaseUnit: v?.isBaseUnit,
              parentUnitId: v?.parentUnitId,
              parentUnitName: v?.parentUnitName,
              conversionFactor: v?.conversionFactor,
              unitCategory: v?.unitCategory,
              compositeStructure: v?.compositeStructure,
              compositeUnits: v?.compositeUnits,
              decimalPlaces: v?.decimalPlaces,
              allowFractional: v?.allowFractional,
            };
          });

          if (exportType >= 1) {
            setExportUnitData(unitData);
            if (exportType === 1) {
              exportCsv(unitData);
            } else if (exportType === 2) {
              exportPDF(unitData);
            } else if (exportType === 3) {
              exportExcel(unitData);
            }
          } else {
            setUnitsList(unitData);
            setLoading(false);
            // setTotalRecords(res.result?.totalRecords);
          }
          setTotalRecords(res.result?.totalRecords);
        } else if (res.result?.items?.length === 0) {
          setUnitsList([]);
          setTotalRecords(res.result.totalRecords);
        }
        setLoading(false);
      })
      .catch((ex: any) => {
        console.error(ex.message);
        setLoading(false);
        setUnitsList([]);
      });
  };

  const deleteUnitId = async () => {
    let res = await ItemsService.deleteUnitId(currentClient?.id, unitData?.id);
    if (res?.status) {
      console.log("data", res);
      setConfirmation(false);
      setTrigger((x) => !x);
      openNotification("success", "Unit deleted successfully");
    } else {
      setConfirmation(false);
      openNotification("error", res.message);
    }
  };

  // Table Search Inide

  const handleSearch = (
    selectedKeys: string[] | any,
    confirm: any,
    dataIndex: DataIndex
  ) => {
    let prevValue = searchColumns[dataIndex]; // check this input value present or notPresent
    let newValue = selectedKeys; // user input filed value
    if (!newValue || newValue?.length === 0) {
      confirm();
      setOpenDropdown(null);
      return;
    }

    let newSearchColumns = { ...searchColumns };
    switch (dataIndex) {
      case "name":
      case "shortName":
        newSearchColumns[dataIndex] = selectedKeys[0];
        break;
      case "type":
      case "unitCategory":
        newSearchColumns[dataIndex] = selectedKeys;
        break;
    }
    const hadPreviousValue = Array.isArray(prevValue)
      ? prevValue.length > 0
      : !!prevValue;
    const hasNewValue = Array.isArray(newValue)
      ? newValue.length > 0
      : !!newValue;

    if (!hadPreviousValue && hasNewValue) {
      setSearchColumnCount((prev) => prev + 1);
    }

    setSearchColumns(newSearchColumns);
    confirm();
    setOpenDropdown(null); // Close the dropdown
  };

  const handleReset = (
    clearFilters: () => void,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    clearFilters();
    confirm();

    let prevValue = searchColumns[dataIndex];

    // Check if there was a previous value
    const hadValue = Array.isArray(prevValue)
      ? prevValue.length > 0
      : !!prevValue;

    if (hadValue) {
      setSearchColumnCount((prev) => prev - 1);
      setSearchColumns((prev: any) => {
        const newSearchColumns = { ...prev };
        if (dataIndex === "type" || dataIndex === "unitCategory") {
          newSearchColumns[dataIndex] = null;
        } else {
          delete newSearchColumns[dataIndex];
        }
        return newSearchColumns;
      });
    }
  };

  const handleDropdownText = (
    dataIndex: DataIndex,
    valDropDown: TextSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "name":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          unitNameDropEnum: valDropDown,
        });
        break;
      case "shortName":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          shortNameDropEnum: valDropDown,
        });
        break;
    }
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    searchPlaceHolder?: string
  ): TableColumnType<IUnitDataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        {dataIndex === "type" ? (
          <Checkbox.Group
            options={UnitTypesOption}
            style={{
              marginBottom: 8,
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
            // value={searchColumns.gstRate}
            value={selectedKeys}
            onChange={(e: any) => {
              setSelectedKeys(e ? [...e] : []);
            }}
          />
        ) : dataIndex === "unitCategory" ? (
          <Checkbox.Group
            options={[
              { label: "Simple", value: 0 },
              { label: "Compound", value: 1 },
            ]}
            style={{
              marginBottom: 8,
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
            value={selectedKeys}
            onChange={(e: any) => {
              setSelectedKeys(e ? [...e] : []);
            }}
          />
        ) : (
          <>
            <Select
              defaultValue={TextSearchTableEnum.contains}
              style={{
                width: "100%",
                maxWidth: "200px",
                marginBottom: "8px",
              }}
              onChange={(val: TextSearchTableEnum) => {
                setExportUnitData([]);
                handleDropdownText(dataIndex, val);
                // setTextTypeSearchColumn(val);
                // setType(1);
              }}
              options={TextSearchTableOption?.map((x: any) => ({
                value: x.value,
                label: x.label,
              }))}
            />

            <Input
              ref={searchInput}
              placeholder={`Search.. ${searchPlaceHolder}`}
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() =>
                handleSearch(selectedKeys as string[], confirm, dataIndex)
              }
              style={{ marginBottom: 8, display: "block", width: "200px" }}
            />
          </>
        )}
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            // icon={<SearchOutlined />}
            size="small"
            style={{ width: 95 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 95 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) =>
      searchPlaceHolder ? (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ) : (
        <FilterOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    filterDropdownOpen: openDropdown === dataIndex,
    filterDropdownProps: {
      placement: "bottomLeft",
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setOpenDropdown(dataIndex);
        setTimeout(() => {
          if (dataIndex === "type") {
            searchSelect.current?.focus(); // Use focus for Select component
          } else {
            searchInput.current?.select(); // Use select for Input component
          }
        }, 100);
      } else {
        setOpenDropdown(null);
      }
    },
  });

  const permissionEdit = findUserOnlyOnePremission(
    "Master.Item.Unit.Edit",
    clientSpecificRole(),
    currentClient?.id!
  );

  const permissionDelete = findUserOnlyOnePremission(
    "Master.Item.Unit.Delete",
    clientSpecificRole(),
    currentClient?.id!
  );

  // --------- Units Table Columns  ---------
  const itemColumns: ColumnsType<IUnitDataType> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      width: "5%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "N",
      width: "40%",
      sorter: true,
      defaultSortOrder: "ascend",
      filteredValue: searchColumns.name ? [searchColumns.name] : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.name}
        </Skeleton>
      ),
      ...getColumnSearchProps("name", "Full Name"),
    },
    {
      title: "Category",
      dataIndex: "unitCategory",
      key: "UC",
      width: "15%",
      sorter: true,
      filteredValue:
        searchColumns.unitCategory || searchColumns.unitCategory === false
          ? searchColumns.unitCategory
          : null,
      render: (_, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.unitCategory === 0 ? "Simple" : "Compound"}
        </Skeleton>
      ),
      ...getColumnSearchProps("unitCategory"),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "T",
      // width: "35%",
      sorter: true,
      filteredValue:
        searchColumns.type || searchColumns.type === false
          ? searchColumns.type
          : null,
      render: (_, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {UnitTypes[record?.type]}
        </Skeleton>
      ),
      ...getColumnSearchProps("type"),
    },
    {
      title: "Short Name",
      dataIndex: "shortName",
      key: "SN",
      sorter: true,
      filteredValue: searchColumns.shortName ? [searchColumns.shortName] : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.shortName}
        </Skeleton>
      ),
      ...getColumnSearchProps("shortName", "Short Name"),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "edit",
      render: (record: IUnitDataType) =>
        record?.system === false ? (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            <Row gutter={8}>
              {permissionEdit && (
                <Col>
                  <Tooltip title="Edit" placement="top" color="#3D4998">
                    <EditOutlined
                      // className="ca-edit-btn"
                      style={{
                        color: "#444653",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setOpenModel(true);
                        setUnitData({
                          id: record?.id,
                          companyId: record?.companyId,
                          name: record?.name,
                          type: record?.type,
                          shortName: record?.shortName,
                          unitCategory: record?.unitCategory,
                          compositeUnits: record?.compositeUnits,
                          decimalPlaces: record?.decimalPlaces,
                        });
                      }}
                    />
                  </Tooltip>
                </Col>
              )}
              {permissionDelete && (
                <Col>
                  <Tooltip title="Delete" placement="top" color="red">
                    <DeleteOutlined
                      // className="ca-edit-btn"
                      onClick={() => {
                        setUnitData({ id: record.id, name: record.name });
                        setConfirmation(true);
                      }}
                      style={{
                        color: "red",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                </Col>
              )}
            </Row>
          </Skeleton>
        ) : (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            <Row gutter={8}>
              {permissionEdit && (
                <Col>
                  <Tooltip title="Not Editable" placement="top" color="#3D4998">
                    <EditOutlined
                      style={{ color: "rgb(216 207 207)", cursor: "pointer" }}
                    />
                  </Tooltip>
                </Col>
              )}
              {permissionDelete && (
                <Col>
                  <Tooltip
                    title="Default unit are not delete"
                    placement="top"
                    color="#3D4998"
                  >
                    <DeleteOutlined
                      style={{ color: "rgb(216 207 207)", cursor: "pointer" }}
                    />
                  </Tooltip>
                </Col>
              )}
            </Row>
          </Skeleton>
        ),
    },
  ];

  let path = "Unit List";
  const columnsA = ["S.No.", "Full Name", "Type", "Category", "Short Name"];

  const fieldMapping = {
    "S.No.": (item: any) => item?.sno,
    "Full Name": (item: any, index: number) => item?.name,
    Type: (item: any, index: number) => UnitTypes[item?.type],
    Category: (item: any, index: number) =>
      item?.unitCategory === 0 ? "Simple" : "Compound",
    "Short Name": (item: any, index: number) => item?.shortName,
  };
  const [tableParams, setTableParams] = useState<ICbTableParams>({
    search: "",
    sortCol: "",
    sortDir: "",
  });

  const generateFooterRow = (columns: string[]) => {
    return columns.map((col) => {});
  };

  const exportCsv = (exportData: any[]) => {
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      "",
      path,
      currentClient?.businessName
    );
    setExportType(0);
  };

  const exportPDF = (exportData: any[]) => {
    // InvoiceExportService.generatePDF(
    //   exportData,
    //   currentClient?.businessName,
    //   columnsA,
    //   fieldMapping,
    //   generateFooterRow,
    //   "",
    //   path
    // );
    InvoiceExportService.AutoDownloadPDF(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const exportExcel = async (exportData: any[]) => {
    await InvoiceExportService.generateExcel(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportUnitData.length > 0) {
              exportCsv(exportUnitData);
            } else {
              setExportType(1);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            if (exportUnitData.length > 0) {
              exportPDF(exportUnitData);
            } else {
              setExportType(2);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            if (exportUnitData.length > 0) {
              exportExcel(exportUnitData);
            } else {
              setExportType(3);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  return (
    <Card
      size="small"
      className="TableCard"
      style={{
        marginTop: 35,
        boxShadow: "0px 0px 10px 0px #96A1C84D",
      }}
    >
      <Col className="mb-10">
        <Row justify="space-between">
          <Col>
            <Row gutter={15}>
              {findUserOnlyOnePremission(
                "Master.Item.Unit.Add",
                clientSpecificRole(),
                currentClient?.id!
              ) && (
                <Col>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setOpenModel(true)}
                  >
                    Unit
                  </Button>
                </Col>
              )}

              <Col>
                {unitsList.length === 0 ? (
                  <Button icon={<DownloadOutlined />} disabled type="primary">
                    Export
                  </Button>
                ) : (
                  <Popover
                    content={content}
                    placement="rightTop"
                    trigger="hover"
                  >
                    <Button
                      type="default"
                      icon={<DownloadOutlined />}
                      // onClick={() => exportCsv()}
                    >
                      Export
                    </Button>
                  </Popover>
                )}
              </Col>
            </Row>
          </Col>
          <Col>
            <Input
              allowClear
              style={{ width: "220px" }}
              placeholder="Search.."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              suffix={loading || searchUnit ? "" : <SearchOutlined />}
            />
          </Col>
        </Row>
        <CbTableWithPagination
          className={`table-${themeData?.componentSize ?? "middle"}`}
          columns={itemColumns}
          dataSource={
            loading
              ? (Array.from({ length: pagingItems.pageSize }, (_, index) => ({
                  key: `loading-${index}`,
                })) as IUnitDataType[])
              : unitsList
          }
          totalRecords={totalRecords}
          loading={loading}
          setTableParams={setTableParams}
          pagingItems={pagingItems}
          setPagingItems={setPagingItems}
          tablePageSize={themeData?.tablePageSize ?? 15}
          pageSizeOptions={tablePageSizeOptions}
          showQuickJumper={false}
          onTableChange={(pagination, filters, sorter) => {
            const singleSorter = Array.isArray(sorter) ? sorter[0] : sorter;
            setfilter({
              sortCol: singleSorter?.columnKey
                ? String(singleSorter.columnKey)
                : "number",
              sortDir:
                singleSorter?.order === "descend"
                  ? "desc"
                  : singleSorter?.order === "ascend"
                  ? "asc"
                  : "desc",
            });
            setExportType(-1);
          }}
        />
        {openModel && (
          <UnitModel
            open={true}
            data={unitData}
            onCancel={() => setOpenModel(false)}
            setTrigger={setTrigger}
          />
        )}

        {confirmation && (
          <ConfirmationModal
            open={confirmation}
            onNo={() => {
              setConfirmation(false);
            }}
            onYes={deleteUnitId}
            text={`Are you sure you want to delete ${unitData?.name}`}
          />
        )}
      </Col>
    </Card>
  );
};

export default ItemsUnitsTable;
